import type LocationPickerState from 'owa-location-common-well/lib/store/schema/LocationPickerState';
import { cacheLocationSuggestionsState } from '../mutators/cacheLocationSuggestionsState';

export function onLocationSuggestionsStateChanged(state: Partial<LocationPickerState>) {
    cacheLocationSuggestionsState(state);
}
